<template>
  <Layout>
    <Content :style="{'padding': '10px'}">
      <Card :style="{'padding':'0px 5px','margin-bottom':'5px'}">
		<span class="search_span_width">
			<span class="search_span_width_part1">分组：</span>
			<Select v-model="search.group_id" clearable  style="width:130px" >
				   <Option :value='1'>默认</Option>
				   <Option :value='2'>智慧零售</Option>
			</Select>
		</span>
		<span class="search_span_width">
		<span class="search_span_width_part1">数智人ID：</span>
			<Input v-model="search.figure_id" style="width: 80px" clearable/>
		</span>
		<span class="search_span_width">
		<span class="search_span_width_part1">数智人主播名称：</span>
			<Input v-model="search.AnchorName" style="width: 130px" clearable/>
		</span>
        <span class="search_span_width">
        <span class="search_span_width_part1">数智人主播 code：</span>
        <Input v-model="search.AnchorCode" style="width: 130px" clearable/>
        </span>
        <span class="search_span_width">
	         <span class="search_span_width_part1">数智人 virtualmankey：</span>
	       		<Input v-model="search.virtualmankey" style="width: 130px" clearable/>
	       	</span>
        <Button type='primary' icon="ios-search" :style="{'margin-left':'20px'}" @click="getList(1)">搜索</Button>
      </Card>
      <Card>
        <Card id="tableContent" >
          <Table :columns="tableColumns" :data="list"></Table>
          <Page :total="recordTotal" :current="page" :page-size="20" :show-elevator="true" @on-change="getList"/>
        </Card>
      </Card>
      <Modal v-model="showmodal" :footer-hide=true title="详情" width="700" >
        <Form ref="speaker"  :label-width="150" >
          <FormItem label="数智人主播名称" prop="intro">
            <Input  v-model="info.AnchorName" readonly/>
          </FormItem>
          <FormItem label="数智人主播 code" prop="intro">
            <Input  v-model="info.AnchorCode" readonly/>
          </FormItem>
          <FormItem label="数智人类型" prop="intro">
            <Input  v-model="info.VirtualmanType" readonly/>
          </FormItem>
          <FormItem label="数智人类型 code" prop="intro">
            <Input  v-model="info.VirtualmanTypeCode" readonly/>
          </FormItem>
          <FormItem label="数智人 virtualmankey" prop="intro">
            <Input  v-model="info.VirtualmanKey" readonly/>
          </FormItem>
          <FormItem label="数智人服装名称" prop="intro">
            <Input  v-model="info.ClothesName" readonly/>
          </FormItem>
          <FormItem label="数智人姿态" prop="intro">
            <Input  v-model="info.PoseName" readonly/>
          </FormItem>
          <FormItem label="数智人分辨率" prop="intro">
            <Input  v-model="info.Resolution" readonly/>
          </FormItem>
          <FormItem label="数智人头像" prop="intro">
            <img :src="info.HeaderImage" :style="{'width':'100px'}"/>
          </FormItem>
          <FormItem label="数智人姿态图片" prop="intro">
            <img :src="info.PoseImage" :style="{'width':'100px'}"/>
          </FormItem>
          <FormItem label="数智人服装" prop="intro">
            <img :src="info.ClothesImage" :style="{'width':'100px'}"/>
          </FormItem>
          <FormItem label="数智人支持的驱动类型" prop="intro">
            <Input  v-model="info.SupportDriverTypes" readonly/>
          </FormItem>
          <FormItem label="数智人可配置形象参数说明，目前仅包含3D服装变色参数" prop="intro">
            <Input  v-model="info.SupportAnchorExtraParams" readonly/>
          </FormItem>
          <FormItem label="数智人累计调用时长，单位为毫秒" prop="intro">
            <Input  v-model="info.VideoDuration" readonly/>
          </FormItem>
          <FormItem label="数智人累计视频个数" prop="intro">
            <Input  v-model="info.VideoNum" readonly/>
          </FormItem>
          <FormItem label="有效期" prop="intro">
            <Input  v-model="info.ExpireDate" readonly/>
          </FormItem>
          <FormItem label="缩放系数，保留三位小数" prop="intro">
            <Input  v-model="info.OriginZoom" readonly/>
          </FormItem>
          <FormItem label="选用视频片段" prop="intro">
            <video ref="audio" controls="controls" :src="info.ReferenceVideoSegmentUrl" width='30%'></video>
          </FormItem>
        </Form>
      </Modal>
    </Content>
  </Layout>
</template>
<script>
export default {
  data(){
    return {
      search : {
        AnchorName:'',
        virtualmankey:'',
        AnchorCode:'',
		group_id: 1,
		figure_id:''
      },
      page: 1,
      loading2: false,
      recordTotal:0,
      showmodal:false,
      list:[],
      info:{
        AnchorName:"",
        AnchorCode:"",
        VirtualmanType:"",
        VirtualmanTypeCode:"",
        VirtualmanKey:"",
        ClothesName:"",
        PoseName:"",
        Resolution:"",
        HeaderImage:"",
        PoseImage:"",
        ClothesImage:"",
        SupportDriverTypes:"",
        SupportAnchorExtraParams:"",
        VideoDuration:"",
        VideoNum:"",
        ExpireDate:"",
        OriginZoom:"",
        ReferenceVideoSegmentUrl:"",
      },
      tableColumns:[
        { title: 'ID', key: 'id', align: 'center',width:'80px' },
		{ title: 'FIGURE_ID', key: 'figure_id', align: 'center',width:'80px' },
        { title: '数智人主播名称', key: 'AnchorName', align: 'center',width:'220px' },
        { title: '数智人头像', key: 'HeaderImage', align: 'center' ,
          render:(h,params) =>{
            return h('img',{
              attrs : {src : params.row.HeaderImage},
              style : { width : '80px'}
            })
          }},
        { title: '数智人主播 code', key: 'AnchorCode', align: 'center' },
        { title: '数智人类型', key: 'VirtualmanType', align: 'center' },
        { title: '数智人类型 code', key: 'VirtualmanTypeCode', align: 'center' },


        { title: '有效期', key: 'ExpireDate', align: 'center' },

        { title: '操作', key: 'sample',
          render: (h, params) => {
            let btns=[]
            btns.push(
                h('Button', {
                  props: { type: 'warning', size: 'small' },
                  style: { marginRight: '5px', marginBottom: '5px'},
                  on: {
                    click: () => {
                      this.info.AnchorName = params.row.AnchorName;
                      this.info.AnchorCode = params.row.AnchorCode;
                      this.info.VirtualmanType = params.row.VirtualmanType;
                      this.info.VirtualmanTypeCode = params.row.VirtualmanTypeCode;
                      this.info.VirtualmanKey = params.row.VirtualmanKey;
                      this.info.ClothesName = params.row.ClothesName;
                      this.info.PoseName = params.row.PoseName;
                      this.info.Resolution = params.row.Resolution;
                      this.info.HeaderImage = params.row.HeaderImage;
                      this.info.PoseImage = params.row.PoseImage;
                      this.info.ClothesImage = params.row.ClothesImage;
                      this.info.SupportDriverTypes = params.row.SupportDriverTypes;
                      this.info.SupportAnchorExtraParams = params.row.SupportAnchorExtraParams;
                      this.info.VideoDuration = params.row.VideoDuration;
                      this.info.VideoNum = params.row.VideoNum;
                      this.info.ExpireDate = params.row.ExpireDate;
                      this.info.OriginZoom = params.row.OriginZoom;
                      this.info.ReferenceVideoSegmentUrl = params.row.ReferenceVideoSegmentUrl;
                      this.showmodal = true;
                    }
                  }
                }, '详情'),
            );
            return h("div",btns);
          }
        },
      ]
    }
  },
  mounted:function(){
    this.getList();
  },
  computed:{

  },
  methods:{
    getList(page=this.page) {
      this.page = page;
      let p = {'page' : page}
      let params = Object.assign(this.search, p);
      this.http1.get('/figure/figure-xiaowei-list',{params:params}).then(response=>{
        let data=response.data;
        if(data.code!==0){
          alert(data.message);
        } else{
          this.list = data.res.list;
          this.recordTotal = data.res.total;
        }
      }).catch(()=>{
        this.$Message.error('网络错误');
      });
    }
  }

}
</script>
